"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestartExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
const configs_1 = require("../../../../configs/configs");
const InchcapeSelectorEvents_1 = require("../../Enum/InchcapeSelectorEvents");
class RestartExtension extends WidgetExtensionPlugin_1.default {
    /**
     * @inheritDoc
     */
    initialize(widget) {
        this.widget = widget;
        this.widget.getEventContainer()
            .on(WidgetEvents_1.WidgetEvents.STEP_READY, this.registerRestartEvents.bind(this));
        return Promise.resolve();
    }
    /**
     * Registers restart elements.
     */
    registerRestartEvents() {
        const restartElements = this.widget.getContainer().querySelectorAll(`[data-px-action="${configs_1.configs.actions.restart}"]`);
        for (let i = 0, element; element = restartElements[i]; ++i) {
            const shouldResetState = element.getAttribute('data-px-action-type') === configs_1.configs.actions.reset;
            element.addEventListener("click", this.restartWidget.bind(this, shouldResetState));
        }
    }
    /**
     * Restarts the widget.
     */
    restartWidget(resetState) {
        resetState ? this.resetState() : this.restartState();
        // Set the first step.
        this.widget.setStep(1).then((set) => {
            if (set) {
                this.widget.getEventContainer().emit(InchcapeSelectorEvents_1.InchcapeSelectorEvents.RESTARTED, this.widget.getState().getAllCloned());
            }
        });
    }
    /**
     * Restarts the state.
     */
    restartState() {
        const state = this.widget.getState();
        const valuation = state.getValuation();
        // In case the valuation was completed there is no point restarting the widget
        // with it as it is already unmodifiable so we duplicate it and let it be
        // created new one.
        if (valuation && valuation.isCompleted()) {
            valuation.setToken(null);
            valuation.setCompleted(false);
        }
    }
    resetState() {
        this.widget.getState().resetState();
        this.widget.getState().update();
    }
}
exports.default = RestartExtension;
exports.RestartExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "restart",
    class: RestartExtension
});
